angular.module('unica_notification.notification_services', []);